import styled from "styled-components";
import { Variables } from "../../../styles/Variables";

export const Container = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  width: 100%;
  height: 30%;
`;

export const ContainerIcons = styled.div`
  position: absolute;
  z-index: 20;
  right: 10px;
  top: 10px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 60px;
  height: 30px;
  background-color: ${Variables.colorWhite};
  border-radius: 20px;
  box-shadow: 0 0 10px #000;
`;

export const ContainerDelete = styled.div`
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

export const ContainerEdit = styled.div`
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

export const ContainerImage = styled.div`
  z-index: 2;
  width: 50%;
  height: 100%;
`;

export const ImageBack = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Left = styled.div`
  box-sizing: border-box;
  z-index: 2;
  padding: 20px 3%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 50%;
  border-radius: 5px;
  color: ${Variables.colorBlackDark};
`;

export const Title = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: ${Variables.colorWhite};

  @media (max-width: ${Variables.maxMobile}) {
    font-size: 12px;
  }
`;

export const Description = styled.p`
  font-size: 12px;
  color: ${Variables.colorWhite};

  @media (max-width: ${Variables.maxMobile}) {
    font-size: 10px;
  }
`;

export const Button = styled.div`
  padding: 10px 0;
  width: 100%;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  border-radius: 30px;
  color: ${Variables.colorBlueKing};
  background-color: ${Variables.colorWhite};
  cursor: pointer;

  @media (max-width: ${Variables.maxMobile}) {
    font-size: 10px;
  }
`;
